// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

(function () {
		// submenu
		let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item')
		itemsMenu.forEach((itemMenu) => {
			if (itemMenu.querySelector('.submenu')) {
				const event =[ "mouseenter", "mouseleave"];
				event.forEach((event) => {
					itemMenu.addEventListener(event, () => {
						itemMenu.classList.toggle('hover')
						itemMenu.querySelector('.submenu').classList.toggle('show')
					})
				})
			}
		})
			const menu_Items = document.querySelectorAll('.burger-menu__nav li:has(.submenu)')
			let prevMenuItem
	
			menu_Items.forEach((element) => {
				// active for link generate in js
				let Main_Link = element.querySelector('a')
				let Link_url = Main_Link.href
				let Element_wrap = element.querySelector('.submenu')
				const newListItem = `
				<li class="primary-nav-js">
					<a tabindex="-1" aria-haspopup="false"  href="${Link_url}">overview</a>
				</li>`
	
				//Element_wrap.insertAdjacentHTML('afterbegin', newListItem)
	
				// active for link generate in js
				if (Main_Link.classList.contains('active')) {
					Main_Link.nextElementSibling.querySelector('a').classList.add('active')
				}
	
				if (
					[...Main_Link.nextElementSibling.querySelectorAll('a')].some((item) =>
						item.classList.contains('active'),
					)
				) {
					Main_Link.nextElementSibling.classList.add('active')
				}
	
				Main_Link.addEventListener('click', (e) => {
					e.preventDefault()
					if (prevMenuItem && prevMenuItem != e.target.nextElementSibling)
						prevMenuItem.classList.remove('active')
					e.target.nextElementSibling.classList.toggle('active')
					prevMenuItem = e.target.nextElementSibling
				})
			})

	//Burger Menu
	const burger_CTAS  = document.querySelectorAll("[data-ctaburger]");
	const burger_Content = document.querySelector("[data-menuburger]");

	burger_CTAS.forEach(currentItem => {
		currentItem.addEventListener('click', (e) =>{
			e.preventDefault();
			burger_Content.classList.toggle("open");
			document.body.classList.toggle("no-scroll");
		});
	});
	

	window.onload = function () {
		scrollW();
		window.addEventListener('scroll', function () {
			scrollW();
		})
	};

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation
	const allInputsSignUp = document.querySelectorAll(".email-signup .input input")
	if (allInputsSignUp) {
		allInputsSignUp.forEach(input => {
			input.setAttribute("placeholder", "Write Here");
			input.addEventListener('focus', function () {
				this.parentElement.classList.add('moved');
			});
		});
	}
	// form inputs add placeholder
	const allInputs = document.querySelectorAll(".form-module__field input,.form-module__field textarea")
	if (allInputs) {
		allInputs.forEach(input => {
			input.setAttribute("placeholder", "Write Here");
		});
	}

	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		let allffields = document.getElementsByClassName('form-module__field');

		for (let j = 0; j < allffields.length; j++) {

			if (allffields[j].getElementsByTagName('input').length > 0) {
				if (allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					})
				}
			}
			if (allffields[j].getElementsByTagName('select').length > 0) {
				allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
			if (allffields[j].getElementsByTagName('textarea').length > 0) {
				allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				})
			}
		}
	}

	//accordion Functionality
	let normal_accordion = document.querySelectorAll("[data-accodion] .tab-js");
	normal_accordion.forEach( (item, i) => {
		item.addEventListener("click", (element) => {
			element.target.classList.toggle("active");
			element.target.nextElementSibling.classList.toggle("active");
		});

		if (i ==0) item.click()
	});

	//Scroll animation
	const allLinks = document.querySelectorAll("[data-scroll], .scroll-js , .btn-scroll");
	allLinks.forEach(link => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			let sectiongoto = link.getAttribute('href').split("#")[1];
			animateTo(sectiongoto);
			if (document.querySelector(".sub-menu__hold") != null && document.querySelector(".sub-menu__hold").classList.contains("open")) {
				document.querySelector(".sub-menu__hold").classList.remove("open")
			}
		});
	});

	// table section
	const tablesResp = document.querySelectorAll('.capacity-chart__copy table');
	if (tablesResp.length) {
			tablesResp.forEach((tablei) => {
					let tableresponsive = document.createElement('div')
					tableresponsive.classList.add('tableHold')
					tablei.parentNode.insertBefore(tableresponsive, tablei)
					tableresponsive.append(tablei)
					const ths = tablei.querySelectorAll('tr:first-child > *')
					tablei.querySelectorAll('tr + tr').forEach((row) => {
							const tds = row.querySelectorAll('td')
							let i = 0
							for (i; i < tds.length; i++) {
									tds[i].setAttribute('data-label', ths[i].textContent)
							}
					})
					const rowHeads = tablei.querySelectorAll('tr td:first-child')
					rowHeads.forEach((ele) => {
							ele.addEventListener('click', (ev) => {
									ele.closest('tr').classList.toggle('active')
							})
					})
			})
	}

})();


	// parallax effect img
	const images = document.querySelectorAll('#home figure img:not(.no-parallax), #default figure img:not(.no-parallax),.parallax');

	new Ukiyo(images,{
			scale: 1.15,
			speed: 1.7,
			willChange: true
	});

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//animation of scroll vanilla JS
function animateTo(target) {
  const element = document.getElementById(target);
  if (!element) return console.warn(`Elemento con ID "${target}" no encontrado.`);

  const gotoTarget = offset(element).top - 100;
  const from = window.pageYOffset;
  const to = gotoTarget; 
  const duration = 1300; 
  const start = performance.now(); 

  function scrollStep(timestamp) {
    const elapsed = timestamp - start; 
    const progress = Math.min(elapsed / duration, 1); 
    const yH = easeInOutQuart(progress) * (to - from) + from; 

    window.scrollTo(0, yH); 

    if (elapsed < duration) {
      requestAnimationFrame(scrollStep); 
    }
  }

  requestAnimationFrame(scrollStep);

  function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  }

  function offset(element) {
    const rect = element.getBoundingClientRect();
    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset
    };
  }
}

/* Subnav on mobile */
let submenuHold = document.querySelectorAll('.sub-menu__hold');
let allsublinks = document.querySelectorAll('.sub-menu a');
if (allsublinks.length > 1) {
	allsublinks.forEach(ele => {
		ele.addEventListener('click', function (ev) {
			if (ele.classList.contains('active')) {
				ev.preventDefault();
			}
		});
	});
	let toggleBtn = document.querySelector('.sub-menu__toggle');
	if (toggleBtn) {
		//toggleBtn.textContent = document.querySelector('.sub-menu a.active').textContent;
		toggleBtn.addEventListener('click', function () {
			toggleBtn.parentElement.classList.toggle('open');
		});
	}
} else if (submenuHold.length > 0) {
	submenuHold[0].classList.add('hidden');
}